import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import voca from 'voca';
import parser from 'cron-parser';
import moment from 'moment';
import { getKeyOfFrequnecy } from '../../common/utils/schedule-utils';
import { drapcodeIcon } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';

const ScheduleTaskRow = ({
  task,
  projectId,
  version,
  handleDelete,
  handlePause,
  handleResume,
  deleteFlag,
}) => {
  let expression = '0 0 */1 * *';
  if (task.interval) {
    expression = task.interval;
  }
  const exParser = parser.parseExpression(expression);
  const [interval, setinterval] = useState(exParser);
  const { name, taskType, uuid, isPaused } = task;
  return (
    <tr>
      <td>{name}</td>
      <td>{getKeyOfFrequnecy(task.interval)}</td>
      <td>{moment(interval.prev().toString()).format('DD MMM YYYY HH:mm')}</td>
      <td>{moment(interval.next().toString()).fromNow()}</td>
      <td>{voca.replaceAll(voca.titleCase(taskType), '_', ' ')}</td>
      <td className="align-middle">
        {isPaused ? (
          <button
            type="button"
            className="btn btn-xs btn-theme-green"
            title={`Resume ${name}`}
            onClick={() => handleResume(uuid)}
          >
            <i className={`wb ${drapcodeIcon('resume')}`} size={'md'}></i>
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-xs btn-theme-green"
            title={`Pause ${name}`}
            onClick={() => handlePause(uuid)}
          >
            <i className={`wb ${drapcodeIcon('pause')}`} size={'md'}></i>
          </button>
        )}
        &nbsp;
        <Link
          className="btn btn-theme-submit btn-xs"
          to={`/2.0/schedule/${version}/v/${projectId}/detail/${uuid}`}
          title={`View ${name}`}
        >
          <i className={`wb ${drapcodeIcon('showModal')}`} size={'md'}></i>
        </Link>
        &nbsp;
        <Link
          className="btn btn-primary btn-xs"
          to={`/2.0/schedule/${version}/v/${projectId}/update/${uuid}`}
          title={`Edit ${name}`}
        >
          <i className={`wb ${drapcodeIcon('edit')}`} size={'md'}></i>
        </Link>
        &nbsp;
        <button
          type="button"
          className="btn btn-xs btn-theme-delete"
          style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
          title={`Delete ${name}`}
          onClick={() => (deleteFlag ? handleDelete(task.uuid) : undefined)}
        >
          <i className={`wb ${drapcodeIcon('delete')}`} size={'md'}></i>
          {deleteFlag ? null : (
            <>
              &nbsp;
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            </>
          )}
        </button>
      </td>
    </tr>
  );
};

export default ScheduleTaskRow;
